// close modal on clicking outside (rohit - 15 march 2023)
// when click outside on overlay, zoom content should close
let modal = document.querySelector('.product-media-modal');
let modalOverlay = document.querySelector('.product-media-modal__dialog');
$(document).on('click', function(e) {
    if (modal && modal.hasAttribute('open')) {
        // close the modal if clicked on overlay
        if (e.target === modalOverlay) {
            // if close button is found, trigger click functionality
            let closeButton = $(".product-media-modal__toggle")[0];
            if (closeButton) {
                closeButton.click();
            }
        }
    }
});



// check for product page
let isTemplateSearch = !!document.querySelector('body.template-search');


// updates the grid after removing the sidebar - (rohit - 1 march 2023)

// this method updates the grid into 6 grid elements - (rohit - 1 march 2023)
const update6Grid = function() { 
  /*
    let width = $(window).width()
    setTimeout(() => {
        let productGridSelector = isTemplateSearch ? '.grid.product-grid' : '#product-grid'
        let productGrid = document.querySelector(productGridSelector);
        if (productGrid) {
            productGrid.style.display = 'grid';
            if (width < 394)
              productGrid.style.gridTemplateColumns = 'repeat(auto-fill,177px)';              
            else if (width < 1055 && width > 395 )
              productGrid.style.gridTemplateColumns = 'repeat(auto-fill,189px)';
            else
                productGrid.style.gridTemplateColumns = 'repeat(auto-fill,250px)';
        }

        let gridItemSelector = isTemplateSearch ? 'li.grid__item' : '.grid__item.mx-w'
        let elements = Array.from(document.querySelectorAll(gridItemSelector));
        for (let element of elements) {
            element.style.width = '100%';
            element.style.maxWidth = '100%';
        }

    }, 100)
  */
}

/* removes the sidebar for 2 required collections  - (rohit - 1 march 2023) */
var isCollectionPage = window.location.pathname.indexOf('/collections/') > -1;

let requiredCollectionsHandles = ['cheap-sex-toys', 'lingerie'];
var getCollectionHandle = function() {
    const currentPath = window.location.pathname;

    let collectionName = '';
    if (currentPath.indexOf('/collections/') > -1) {
        let pathBreadCrumbs = currentPath.split("/");
        collectionName = decodeURIComponent(pathBreadCrumbs[pathBreadCrumbs.indexOf('collections') + 1]);
    }

    return collectionName
}

// check if its a desktop/mobile  - (rohit - 1 march 2023)
var isDesktop = window.matchMedia("(min-width: 1100px)").matches; // checks for 750px as threshold

//  if we get required collections, remove the filter section on left side and update the grid to 6-element grid.
if (true) {
    let collectionHandle = getCollectionHandle(); // checks the current collection handle
    let conditionsNeededToUpdateGrid = (collectionHandle && requiredCollectionsHandles.indexOf(collectionHandle) > -1) || isTemplateSearch;
    if (conditionsNeededToUpdateGrid) {
        let aside = document.querySelector('aside.facets-wrapper');
        let filterMenu = document.querySelector('.mobile-facets__disclosure')
        if (aside) {
            aside.remove();
            update6Grid();
            // add mutation observer when the page updates when load-more / pagination is trigerred
            let observer = new MutationObserver(mutations => {
                update6Grid();
            });
            if (filterMenu) {
                filterMenu.remove();
                update6Grid();

                let observer = new MutationObserver(mutations => {
                    update6Grid();
                });
            }
            let demoElem = document.getElementById('product-grid');
            observer.observe(demoElem, {
                childList: true,
                subtree: true
            });
        }

        // check if its a search page and no filter
        if(isTemplateSearch){
          update6Grid();
        }
    }

}
$(window).resize(function() {
    update6Grid();
})


/* pills for sort by  - rohit (2 march 2023)*/


// on click, set url parameters and reloads the page
let sortPills = Array.from(document.querySelectorAll('.sort-pill'));
if (sortPills && sortPills.length) {
    for (let sortPill of sortPills) {
        sortPill.addEventListener('click', (e) => {
            let sortByValue = e.target.getAttribute('data-val');
            if (!sortByValue)
                sortByValue = e.target.querySelector('span.sort-pill-text').getAttribute('data-val');

            if (!sortByValue) {
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.delete('sort_by');
            urlParams.set('sort_by', sortByValue);
            let newUrl = `${window.location.origin}${window.location.pathname}?${decodeURIComponent(urlParams.toString())}`
            window.location.href = newUrl;

        })
    }
}



// set currently selected pill - check from url
if (isCollectionPage) {
    let currentSortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (!currentSortBy) {
        currentSortBy = document.querySelector('#default-sort');
        if (currentSortBy) {
            currentSortBy = currentSortBy.getAttribute('data-value');
        }
    }
    let pillTexts = Array.from(document.querySelectorAll('.sort-pill-text'));
    if (currentSortBy) {
        for (let pillText of pillTexts) {
            pillText.parentNode.classList.remove('active');
            let dataValAttribute = pillText.getAttribute('data-val');
            if (dataValAttribute === currentSortBy) {
                pillText.parentNode.classList.add('active');
            }
        }
    }

}

function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}



// product badges - rohit 4 march 2023

const setProductBadges = function() {
    let productBadges = Array.from(document.querySelectorAll('span.product-badge'));
    for (let productBadge of productBadges) {
        let tags = productBadge.getAttribute('data-tags');
        if (!tags || !tags.length) {
            continue;
        }
        let tagsArray = tags.split(',').filter(x => !!x);
        if (tagsArray.indexOf('best-seller') > -1) {
            productBadge.classList.add('best-seller');
            productBadge.innerHTML = 'Best Seller'
            continue;
        }
        if (tagsArray.indexOf('new-arrival') > -1) {
            productBadge.classList.add('new-arrival');
            productBadge.innerHTML = 'New'
            continue;
        }
        if (tagsArray.indexOf('top-rated') > -1) {
            productBadge.classList.add('top-rated');
            productBadge.innerHTML = 'Top Rated'
            continue;
        }
    }
}


document.addEventListener("DOMContentLoaded", function() {
    let badgeObserver = new MutationObserver(mutations => {
      setProductBadges();
    });

    let productGrid = document.getElementById('product-grid');
    if (productGrid) {
      badgeObserver.observe(productGrid, {
        childList: true
      });
      setProductBadges();
    }
  });

// Redirect to url specified if not redirected using A tag
  $('.navigation-header-links').click(function() {
    var hrefValue = $(this).attr('href');
  window.location = hrefValue
  });